import XTbl,{Xtc} from '../../components/x-table/index';
const tbl = new XTbl('/communication/email-log/query/', 'log_email');

// tbl.add(new Xtc('recorded_time', 'Recorded time'))
tbl.add(new Xtc('date', 'Date').renderSlot('time'))
tbl.add(new Xtc('matter', 'Matter').renderSlot('matter'))
tbl.add(new Xtc('subject', 'Subject'))
tbl.add(new Xtc('from_user', 'Users').renderSlot('from'))
//tbl.add(new Xtc('to_contacts', 'Contacts').renderSlot('to'))
tbl.add(new Xtc('action', 'Action').noSort().renderSlot('action'))

export default tbl;

